module.exports = __webpack_public_path__ + "img/presential.adb49b88.svg";